import React from 'react'
import styles from './BackButton.module.css'

const BackButton = ({ onClick, children, className = '', disabled = false, ...rest }) => {
  const label = typeof children === 'string' ? children : 'Retour'

  return (
    <button
      type="button"
      className={[styles.backBtn, className].filter(Boolean).join(' ')}
      onClick={onClick}
      disabled={disabled}
      aria-label={`Retour : ${label}`}
      {...rest}
    >
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
      {children}
    </button>
  )
}

export default BackButton
